import { Directive, forwardRef } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";
import { validationRegex } from "@obg/ngx.global";

@Directive({
	selector: "[obgNumericNotZero]",
	providers: [
		{
			provide: NG_VALIDATORS,
			// eslint-disable-next-line @angular-eslint/no-forward-ref
			useExisting: forwardRef(() => NumericNotZeroValidatorDirective),
			multi: true,
		},
	],
})
export class NumericNotZeroValidatorDirective implements Validator {
	validate(control: AbstractControl): { numericNotZero: boolean } | null {
		return control.value && control.value.toString().match(validationRegex.numberNotZero)
			? null
			: { numericNotZero: false };
	}
}
